import * as actionTypes from './auth.actionTypes';

export const initialState = {
    user: null,
    tokens: null,
    isLoggedIn: false,
    rememberMe: false,
    loginCredentials: null,
    isLoading: false,
    // Login 2FA: while true, LoginForm shows the code-entry step instead of the credentials
    // form. twoFactorUserId is who the pending code belongs to (submitted alongside the code —
    // no password re-entry needed).
    requiresTwoFactor: false,
    twoFactorUserId: null
};

//-----------------------|| AUTH REDUCER ||-----------------------//

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REGISTER_USER:
            return {
                ...state,
                isLoading: true
            };
        case actionTypes.REGISTER_USER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoggedIn: true,
                isLoading: false
            };
        case actionTypes.REGISTER_USER_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionTypes.LOGIN_USER:
            // Reset any earlier pending-2FA state — a fresh credentials submission (e.g. the
            // user went back and tried a different account) starts the flow over.
            return {
                ...state,
                isLoading: true,
                requiresTwoFactor: false,
                twoFactorUserId: null
            };
        case actionTypes.LOGIN_USER_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoggedIn: true,
                isLoading: false
            };
        case actionTypes.LOGIN_USER_FAILURE:
            return {
                ...state,
                isLoggedIn: false,
                isLoading: false
            };
        case actionTypes.LOGIN_USER_REQUIRES_2FA:
            // rememberMe/loginCredentials are persisted here (not deferred to the eventual
            // VERIFY_LOGIN_2FA_SUCCESS) — the password was already correct, so remembering the
            // email for next visit doesn't need to wait on the code step too.
            return {
                ...state,
                isLoading: false,
                requiresTwoFactor: true,
                twoFactorUserId: action.payload.userId,
                rememberMe: action.payload.rememberMe,
                loginCredentials: action.payload.loginCredentials
            };
        case actionTypes.VERIFY_LOGIN_2FA:
            return {
                ...state,
                isLoading: true
            };
        case actionTypes.VERIFY_LOGIN_2FA_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoggedIn: true,
                isLoading: false,
                requiresTwoFactor: false,
                twoFactorUserId: null
            };
        case actionTypes.VERIFY_LOGIN_2FA_FAILURE:
            // Keep requiresTwoFactor/twoFactorUserId — a wrong code should let the user just
            // retry the code step, not fall back to re-entering the password.
            return {
                ...state,
                isLoading: false
            };
        case actionTypes.RESET_LOGIN_2FA:
            return {
                ...state,
                requiresTwoFactor: false,
                twoFactorUserId: null
            };
        case actionTypes.UPDATE_USER_PROFILE:
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            };
        case actionTypes.LOGOUT:
            // Reset to initialState so redux-persist's snapshot in localStorage no longer
            // claims the user is logged in. Without this, deleting the cookie still left
            // `isLoggedIn=true, user=...` persisted, and EmailListener kept the previous
            // user's socket subscription open until a full page reload.
            return { ...initialState };
        default:
            return state;
    }
};

export default authReducer;
